import { CircularProgress } from '@mui/material';
import {
  ConfirmButtonSkeleton,
  StyledContainer,
  CircularProgressContainer,
} from './styled';

const InfoLoader = () => (
  <StyledContainer>
    <CircularProgressContainer>
      <CircularProgress />
    </CircularProgressContainer>
    <ConfirmButtonSkeleton />
  </StyledContainer>
);

export default InfoLoader;
